import { FC } from 'react';
import { IconButton } from '../iconButton';
import ContainerElementLeft from 'shared/assets/icons/arrow-left.svg';

interface ArrowLeftIconButtonProps {
	onClick: () => void;
}

export const ArrowLeftIconButton: FC<ArrowLeftIconButtonProps> = ({
	onClick,
}) => {
	return (
		<IconButton
			role="arrow-left-button"
			iconSrc={ContainerElementLeft}
			onClick={onClick}
			styles={{ height: '64px' }}
		/>
	);
};
